module.exports = __webpack_public_path__ + "static/media/lloyd led tv.677a8e7f.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/lloyd led tv.gif
// module id = 356
// module chunks = 0